
import { defineComponent } from "vue";

export default defineComponent({
  // Component options
});
